
<template>
  <div class="home-echarts-wrap" :style="{ width, height, marginBottom }">
    <div class="home-echarts-header" style="padding: 10px 24px 0 24px;height: auto">
      <a-radio-group v-model:value="distributionType">
        <a-radio-button :value="1">异动类型分布</a-radio-button>
        <a-radio-button :value="2">异动等级分布</a-radio-button>
      </a-radio-group>
    </div>
    <AlarmDistribution appId="cos_fbu" :distributionType="distributionType.toString()" :formState="props.formState"/>
  </div>
</template>
<script setup lang="ts">
import { PropType } from 'vue/dist/vue'
import { ref } from 'vue'
import AlarmDistribution from './AlarmDistribution.vue'

const props = defineProps({
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '350px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '8px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  formState: {
    type: Object as PropType<Object>
  }
})
// 默认是异动类型 1 异动等级2
const distributionType = ref(1)

</script>
<script lang="ts">
export default { name: 'AlarmPieCombine' }
</script>

<style lang="scss" scoped></style>
